import { createApp } from 'vue'
import App from './App.vue'
import router from './router'; // Import the router

import { library } from '@fortawesome/fontawesome-svg-core';
import { faSnowflake } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faSnowflake);

createApp(App)
    .use(router) // Use the router
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app'); // Mount the app

